import { render, staticRenderFns } from "./StatBox.vue?vue&type=template&id=cdfc9de4&scoped=true&"
import script from "./StatBox.vue?vue&type=script&lang=js&"
export * from "./StatBox.vue?vue&type=script&lang=js&"
import style0 from "./StatBox.vue?vue&type=style&index=0&id=cdfc9de4&lang=scss&scoped=true&"
import style1 from "./StatBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfc9de4",
  null
  
)

export default component.exports